import { Mapper } from "../../../../base/utils/mapper";
import { BackgroundPhysiotherapyResponseModel } from "../../../../domain/models/consult/background-physiotherapy-response.model";
import { BackgroundPhysiotherapyResponseEntity } from "../entities/background-physiotherapy-response.entity";
export class BackgroundPhysiotherapyImplementationRepositoryMapper extends Mapper<BackgroundPhysiotherapyResponseEntity, BackgroundPhysiotherapyResponseModel>{
    mapFrom(param:  BackgroundPhysiotherapyResponseEntity):  BackgroundPhysiotherapyResponseModel { 
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }; 
    }
    mapTo(param: BackgroundPhysiotherapyResponseModel):  BackgroundPhysiotherapyResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors 
        };
    }
}